import styled from "styled-components";
export const HeaderTitleStyleContainer = styled.div `
  width: 100vw;
  height: 60px;
  display: flex;
  align-items: center;
  gap: 20px;
  background: ${(props) => props.theme.colorPalette.whiteColor};
  color: ${(props) => props.theme.colorPalette.primaryColor};
  border-bottom: 2px solid ${(props) => props.theme.colorPalette.primaryColor};
  box-shadow: 0px 0px 4px rgb(0 0 0 / 25%);
  justify-content: space-between;
  text-align: center;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 999;
  .arrow-back-title-wrapper {
    margin-left: 15px;
    display: flex;
    gap: 20px;
  }

  .logo-wrapper {
    margin-right: 15px;
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .title-container {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 16px;
  }
`;
